import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { ImageSlot } from './ImageSlot';
import { SectionHeading } from './SectionHeading';
type BonusesSectionProps = {
  bonusCovers: string[];
};
function Labels({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div className="flex flex-wrap items-center gap-1.5" data-id="element-39" data-mp="qsrsgasq9omu">
      <span className="inline-block rounded-md bg-sun px-2 py-1 font-display text-[11px] font-black tracking-[0.08em] text-ink" data-id="element-40" data-mp="14tkpp3aeyxtn">{label}</span>
      <span className="inline-block rounded-md bg-leaf-soft px-2 py-1 font-display text-[11px] font-black tracking-[0.06em] text-leaf-ink" data-id="element-41" data-mp="ztgbjjwzaf6l">
        {value} VALUE — {bonuses.free}
      </span>
    </div>;
}

/** v2: on mobile the cover is a thumbnail next to the labels (v1 showed it full width), so the section is much
 *  shorter and the offer is closer. */
export function BonusesSection({
  bonusCovers
}: BonusesSectionProps) {
  return <section aria-labelledby="bonuses-title" className="bg-white py-12 md:py-20" data-id="element-42" data-mp="1jgnnlb2nf8hi">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-43" data-mp="3ps4woi3u714w">
        <SectionHeading id="bonuses-title" eyebrow={bonuses.eyebrow} title={bonuses.title} sub={bonuses.sub} data-id="element-44" data-mp="3tr5f3ziek1rd" />

        <ul className="mt-8 grid gap-3 md:mt-12 md:grid-cols-2 md:gap-4" data-id="element-45" data-mp="2kkpmk7zx1wg">
          {bonuses.items.map((b, i) => {
          const featured = i === 0;
          return <li key={b.label} className={`rounded-xl border bg-white p-4 sm:flex sm:items-center sm:gap-6 sm:p-5 ${featured ? 'border-2 border-sun md:col-span-2 md:gap-8 md:p-7' : 'border-hair'}`} data-id="element-46" data-mp="ckboey3la32c" data-mpi={i}>
                {/* Mobile: cover thumbnail + labels side by side, then title and text full width.
                    Fixed square box: the cover is absolutely positioned so it never changes the layout when it loads
                    (otherwise the scroll to #offer lands short on mobile). */}
                <div className="flex items-center gap-4 sm:contents" data-id="element-47" data-mp="al8q57c6adij">
                  <div className={`relative aspect-square w-20 shrink-0 overflow-hidden rounded-lg bg-mist ${featured ? 'sm:w-40 md:w-48' : 'sm:w-36'}`} data-id="element-48" data-mp="aj4lgn6g9ah7">
                    <ImageSlot url={bonusCovers[i]} alt={`${b.title} cover`} slotName={`bonusCovers[${i}]`} fit="contain" className="absolute inset-0" data-id="element-49" data-mp="kba9jltkz7r4" />
                  </div>
                  <div className="min-w-0 sm:hidden" data-id="element-50" data-mp="tbgl325pxxnn">
                    <Labels label={b.label} value={b.value} data-id="element-51" data-mp="ta5ktcbhf81a" />
                    <p className="mt-2 text-[15px] font-semibold leading-snug text-coral-ink" data-id="element-52" data-mp="odf3ymrus8et">{b.hook}</p>
                  </div>
                </div>
                <div className="mt-3 min-w-0 sm:mt-0 sm:flex-1" data-id="element-53" data-mp="137towsuz9rw4">
                  <div className="hidden sm:block" data-id="element-54" data-mp="yc4n0ivhjywn">
                    <Labels label={b.label} value={b.value} data-id="element-55" data-mp="3519inymd3mvb" />
                    <p className="mt-3 text-[15px] font-semibold text-coral-ink" data-id="element-56" data-mp="351sxh6gptv54">{b.hook}</p>
                  </div>
                  <h3 className={`font-display font-extrabold uppercase leading-snug tracking-tight text-brand sm:mt-1 ${featured ? 'text-[17px] sm:text-[18px] md:text-[24px]' : 'text-[17px]'}`} data-id="element-57" data-mp="3049c7mlloi3o">
                    {b.title}
                  </h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-ink/75 sm:mt-2 sm:text-[16px]" data-id="element-58" data-mp="1at5op78jtlqf">{b.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 flex max-w-[560px] items-center justify-center gap-2.5 rounded-xl bg-leaf-soft px-4 py-4 text-center font-display text-[17px] font-black text-leaf-ink md:text-[20px]" data-id="element-59" data-mp="10uzmspmqsflk">
          <GiftIcon className="h-5 w-5 shrink-0" strokeWidth={2.5} aria-hidden="true" data-id="element-60" data-mp="rub6tpdsg561" />
          {bonuses.totalNote}
        </p>
      </div>
    </section>;
}